import { Box, Button, Paper } from '@mui/material';
import React from 'react';

import { getOsSupportedBrowsers } from 'FRONTEND/utils/browser';
import i18n from 'FRONTEND/utils/i18n';
import ChromeLogo from 'SRC/static/images/browsers/chrome-brands.svg';
import EdgeLogo from 'SRC/static/images/browsers/edge-brands.svg';
import FirefoxLogo from 'SRC/static/images/browsers/firefox-brands.svg';
import SafariLogo from 'SRC/static/images/browsers/safari-brands.svg';

import './index.css';

const BROWSER_SUGGESTIONS = {
  chrome: {
    downloadLink: 'https://www.google.com/chrome/',
    logo: <ChromeLogo className='supportedBrowsers-icon' />,
    name: 'Chrome',
  },
  firefox: {
    downloadLink: 'https://www.mozilla.org/firefox/',
    logo: <FirefoxLogo className='supportedBrowsers-icon' />,
    name: 'Firefox',
  },
  safari: {
    downloadLink: 'https://support.apple.com/HT204416',
    logo: <SafariLogo className='supportedBrowsers-icon' />,
    name: 'Safari',
  },
  edge: {
    downloadLink: 'https://www.microsoft.com/edge',
    logo: <EdgeLogo className='supportedBrowsers-icon' />,
    name: 'Edge',
  },
};

const SuggestedBrowsers = ({
  supportedBrowsers = getOsSupportedBrowsers(),
  buttonColor = 'primary',
  children,
}) => {
  return (
    <Box className='supportedBrowsers-container' bgcolor='background.default'>
      <Paper className='supportedBrowsers'>
        <div className='supportedBrowsers-header'>
          <div className='supportedBrowsers-title'>{i18n._('Browser not supported.')}</div>
        </div>
        {children}
        <div className='supportedBrowsers-links'>
          {supportedBrowsers.map((supportedBrowser) => {
            const { downloadLink, logo, name } = BROWSER_SUGGESTIONS[supportedBrowser];
            return (
              <div className='supportedBrowsers-link' key={supportedBrowser}>
                <Button variant='contained' onClick={() => window.open(downloadLink)} color={buttonColor}>
                  {logo}
                  <span>{name}</span>
                </Button>
              </div>
            );
          })}
        </div>
      </Paper>
    </Box>
  );
};

export default SuggestedBrowsers;
